import axios from 'axios';
import { API_BASE_URI } from './apiEndPoint';

const api = {
  post: async (url, data) => {
    try {
      const finalUrl = `${API_BASE_URI}${url}`;
      const res = await axios({
        method: 'post',
        url: finalUrl,
        data,
      });
      return res.data;
    } catch (error) {
      return error;
    }
  },
  get: async (url, data) => {
    const finalUrl = `${API_BASE_URI}${url}`;
    try {
      const res = await axios({
        method: 'get',
        url: finalUrl,
        data,
        // headers: { 'ngrok-skip-browser-warning': '0' },
      });
      return res.data;
    } catch (error) {
      return error;
    }
  },
};

export default api;
